import styled from 'styled-components';
import colors from '../../../../assets/colors';

export const Content = styled.div`
  width: 100%;
  max-width: 900px;

  h2 {
    padding: 25px 30px;
    color: ${colors.primary};
  }

  .tabs {
    padding: 12px 30px;
    background: #E9E9E9;

    ul {
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      
      li {
        font-size: 0.9rem;
        text-transform: uppercase;
        letter-spacing: -0.5px;
        font-weight: 600;
        padding-right: 30px;

        span {
          color: #999999;
          padding: 10px 0;
          border-bottom: 2px solid #E9E9E9;
          cursor: pointer; 

          :hover {
            border-bottom: 2px solid #B3B3B3;
          }
        }

        .fa {
          color: ${colors.red};
          font-size: 1.0rem;
          margin-bottom: -3px;
          margin-left: 7px;
        }

        :last-child { padding-right: 0; }
      }
    }
  }

  button:hover, button:focus {
    -webkit-transition: none;
    -moz-transition: none;
    -o-transition: none;
    transition: none;
  }

  @media screen and (min-width: 620px) {
    .react-tabs__tab--selected span {
      color: ${colors.primary} !important;
      border-bottom: 2px solid ${colors.primary} !important;
    }
  }

  @media screen and (max-width: 619px) {
    .tabs {
      ul {
        display: block;

        li {
          padding: 10px 0;

          span {
            padding: 10px 0;
            border: none;
            
            :hover { border: none; }
          }
        }
      }
    }

    .react-tabs__tab--selected span { color: ${colors.primary} !important; }
  }
`;

export const Footer = styled.div`
  display: flex;
  padding: 30px;
  border-top: 1px solid #E9E9E9;

  .btn-submit {
    flex: 1;
    padding: 13px 0;
    background: #2FAA33;
    background: linear-gradient(180deg,rgba(55,205,63,1) 0%,rgba(41,157,44,1) 100%);
    border: none;
    border-radius: 100px;
    text-transform: uppercase;
    font-size: 0.9rem;
    font-weight: 600;
    color: #FFF;
    font-family: 'Open Sans',sans-serif;
    outline: none;
    cursor: pointer;

    :first-child {
      margin-right: 30px;
      background: none;
      border: ${props => (props.delete ? `2px solid ${colors.red}` : `2px solid ${colors.primary}`)};
      color: ${props => (props.delete ? colors.red : colors.primary)};
      letter-spacing: -0.3px;
    }

    :hover { opacity: .9; }
  }

  @media screen and (max-width: 619px) {
    flex-direction: column;

    button {
      width: 100%;

      :first-child { margin-bottom: 15px; }
    }
  }
`;
